import React from 'react'
import ReactDOM from 'react-dom'

import {PromptMessage} from 'hooks/useBeforeUnloadPrompt'
import DialogComponent from './DialogComponent'

const parseMessage = (raw: string): PromptMessage => {
  try {
    return JSON.parse(raw)
  } catch {
    return {message: raw}
  }
}

const CustomRouterUserConfirmation = (raw: string, callback: (ok: boolean) => void) => {
  const container = document.createElement('div')
  container.setAttribute('custom-confirmation-navigation', '')
  document.body.appendChild(container)

  const closeModal = (callbackState: boolean) => {
    ReactDOM.unmountComponentAtNode(container)
    document.body.removeChild(container)
    callback(callbackState)
  }

  const {title, subTitle, description} = parseMessage(raw)

  ReactDOM.render(
    <DialogComponent
      closeModal={closeModal}
      title={title}
      subTitle={subTitle}
      description={description}
    />,
    container,
  )
}
export default CustomRouterUserConfirmation
